// The opener alone: the first non-blank line, which is what status_opener in
// inrange_agents/portfolio_row.py takes as the opener.
export const statusOpener = (text: string): string =>
  text.split("\n").find((line) => line.trim())?.trim() ?? "";
